import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'core/errors/Error';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import PartnerApiLogs from 'components/partner-api-logs/PartnerApiLogs';
import PartnerApiLogModal from 'components/partner-api-logs/PartnerApiLogModal';
import { resetGetPartnerApiLogsFailure } from 'app/features/partner-api-logs/partnerApiLogSlice';

function ListPartnerApiLogs({ isNetworkError }) {
  const logsState = useSelector((state) => state.partnerApiLogs.index);
  const { isError, errorCode } = logsState;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isError) dispatch(resetGetPartnerApiLogsFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        withInDashboard={true}
        onRetry={() => dispatch(resetGetPartnerApiLogsFailure())}
      />
    );

  return (
    <PageContent title="Partner API Logs">
      <PartnerApiLogs />
      <PartnerApiLogModal />
    </PageContent>
  );
}

export default compose(withAppState)(ListPartnerApiLogs);
